import { hFetch } from '@/lib/hfetch';
import type { WorkflowDefinitionEntity } from './entity_types/workflow/WorkflowDefinition';

export const list = async () => {
  return await hFetch<WorkflowDefinitionEntity[]>({ url: '/api/workflow_definitions' });
};
